import CircuitryIcon from './CircuitryIcon'

export default CircuitryIcon
